import * as constants from "./constants";
import { message } from 'antd';
import electricApi from "@/api/electric";


export const changeElectric = (data,type) => {
    return {
        type: type,
        data
    };
};
//数据补招 - 多个电表批量
export const electricMakeBatch = (data) => {
    return (dispatch) => {
        electricApi.electricMakeBatch(data)
            .then(res => {
                if(res?.code === 200) {
                    message.success('召测成功');
                } else {
                    message.error((res && res.msg) || '网络错误');
                }
            })
    };
};
export const exportElectricList = (data) => {
    return (dispatch) => {
        electricApi.exportElectricList(data)
    }
}
//数据列表
export const getGatewayList = (data) => {
    return (dispatch) => {
        electricApi.getGatewayList(data)
            .then(res => {
                dispatch(changeElectric(res || [],constants.GATEWAY_DATA));
            })
    };
};

//需量数据 - 多个电表需量数据补招
export const demandMakeBatch = (data) => {
    return (dispatch) => {
        electricApi.demandMakeBatch(data)
            .then(res => {
                if(res?.code === 200) {
                    message.success('召测成功');
                } else {
                    message.error((res && res.msg) || '网络错误');
                }
            })
    };
};
//需量数据列表
export const getDemandList = (data) => {
    return (dispatch) => {
        electricApi.getDemandList(data)
            .then(res => {
                dispatch(changeElectric(res || [],constants.DEMAND_DATA));
            })
    };
};


//集中器实时数据
export const getGatewayRealList = (data) => {
    return (dispatch) => {
        electricApi.getGatewayRealList(data)
            .then(res => {
                dispatch(changeElectric((res?.content || []),constants.GATEWAY_REAL));
            })
    };
};
//实时数据补招
export const realTimeElectricMake = (data) => {
    return (dispatch) => {
        electricApi.realTimeElectricMake(data)
            .then(res => {
                if(res?.code === 200) {
                    message.success('召测成功');
                } else {
                    message.error((res && res.msg) || '网络错误');
                }
            })
    };
};

